import { render } from "./MainPage.vue?vue&type=template&id=63e642b2&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=63e642b2&scoped=true&lang=css"
import "./MainPage.vue?vue&type=style&index=1&id=63e642b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e642b2"]])

export default __exports__